import React from 'react';
import { isKronWebView } from '@storebrand-digital/kron-web-view-helpers';

import styles from './Document.Table.module.css';
import DocumentTableBody from './Document.Table.Body';
import DocumentTableHead from './Document.Table.Head';
import DocumentCardList from './Document.CardList';

function DocumentTable() {
  if (isKronWebView) {
    return <DocumentCardList />;
  }

  return (
    <table className={styles.documentTableBase}>
      <DocumentTable.Head />
      <DocumentTable.Body />
    </table>
  );
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace DocumentTable {
  export const Head = DocumentTableHead;
  export const Body = DocumentTableBody;
}

export default DocumentTable;
